var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.43 4.18492H14.13L11.595 1.64992C11.3925 1.44742 11.0625 1.44742 10.8525 1.64992C10.65 1.85242 10.65 2.18242 10.8525 2.39242L12.645 4.18492H5.355L7.1475 2.39242C7.35 2.18992 7.35 1.85992 7.1475 1.64992C6.945 1.44742 6.615 1.44742 6.405 1.64992L3.8775 4.18492H3.5775C2.9025 4.18492 1.5 4.18492 1.5 6.10492C1.5 6.83242 1.65 7.31242 1.965 7.62742C2.145 7.81492 2.3625 7.91242 2.595 7.96492C2.8125 8.01742 3.045 8.02492 3.27 8.02492H14.73C14.9625 8.02492 15.18 8.00992 15.39 7.96492C16.02 7.81492 16.5 7.36492 16.5 6.10492C16.5 4.18492 15.0975 4.18492 14.43 4.18492Z",
    fill: "#81878E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2875 9H3.65249C3.18749 9 2.83499 9.4125 2.90999 9.87L3.53999 13.725C3.74999 15.015 4.31249 16.5 6.80999 16.5H11.0175C13.545 16.5 13.995 15.2325 14.265 13.815L15.0225 9.8925C15.1125 9.4275 14.76 9 14.2875 9ZM7.95749 13.8375C7.95749 14.13 7.72499 14.3625 7.43999 14.3625C7.14749 14.3625 6.91499 14.13 6.91499 13.8375V11.3625C6.91499 11.0775 7.14749 10.8375 7.43999 10.8375C7.72499 10.8375 7.95749 11.0775 7.95749 11.3625V13.8375ZM11.1675 13.8375C11.1675 14.13 10.935 14.3625 10.6425 14.3625C10.3575 14.3625 10.1175 14.13 10.1175 13.8375V11.3625C10.1175 11.0775 10.3575 10.8375 10.6425 10.8375C10.935 10.8375 11.1675 11.0775 11.1675 11.3625V13.8375Z",
    fill: "#81878E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.6ffd83b8.svg";
export { ForwardRef as ReactComponent };